import React, { useState } from "react";
import { MDBCol, MDBRow } from "mdbreact";
import { Button, Text, TextInput } from "evergreen-ui";
import { message, Select } from "antd";
import { useListVals } from "../../../Firebase/databaseHooks";
import Firebase from "../../../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";
import { filterSelectOption, sortSelectOptions } from "../../../utils/selectOptions.js";
const db = getDatabase(Firebase);
const InitiativeProgramActionLayout = (props) => {

	const [name, setName] = useState(null);
	const [code, setCode] = useState(null);
	const [langArray] = useListVals(ref(db, "talmidsdb/languages"));
	const [selectedLang, setSelectedLang] = useState(null);

	const handleLang = (value) => {
		setSelectedLang(value);
	}
	const handleCreate = () => {
		if (!name?.trim() || !code?.trim() || !selectedLang) {
			message.error("Name, code and language are required.");
			return;
		}

		if (code.includes("/")) {
			message.error("Code field cannot include a slash, use a dash or another symbol instead.");
			return;
		}

		var object = {
			"name": name.trim(),
			"programID": code.trim(),
			"language": selectedLang,
			"code": code.trim(),
			"createdBy": props.user?.uid || "unknown",
			"dateCreated": Date.now(),
			"deleted": false,
		}

		setSelectedLang(null); setName(""); setCode("");
		props.createCallback("initiativeTypes", code.trim(), object);

	}

	return (
		<div className="font-Nunito">
			<MDBRow>
				<MDBCol>
					<div className="d-flex flex-column">
						<div className="d-flex flex-column my-2 mt-3">
							<Text className=" mb-1">Enter initiative sector Name</Text>
							<TextInput
								className="w-100"
								name="text-input-name"
								placeholder="enter initiative sector"
								onChange={(e) => { setName(e.target.value) }}
								value={name}
							/>
						</div>

						<div className="d-flex flex-column my-2">
							<Text className=" mb-1">Enter initiative sector Code</Text>
							<TextInput
								className="w-100"
								name="text-input-name"
								placeholder="enter initiative sector code"
								onChange={(e) => { setCode(e.target.value) }}
								value={code}
							/>
						</div>
						<div className="d-flex flex-column my-2">
							<Text className=" mb-1">Select Initiative sector Language</Text>
							<Select placeholder="Select Language"
								value={selectedLang}
								showSearch
								optionFilterProp="children"
								filterOption={filterSelectOption}
								filterSort={sortSelectOptions}
								onChange={handleLang}>
								{langArray.map((item, index) => (
									<Select.Option key={index} value={item.id}>
										{item.languageName}
									</Select.Option>
								))}
							</Select>
						</div>
					</div>
					<Button appearance="primary" className="mt-3" onClick={() => {
						handleCreate();
					}}>Add</Button>
				</MDBCol>
			</MDBRow>
		</div>
	)
}
export default InitiativeProgramActionLayout;
